// extracted by mini-css-extract-plugin
export var previewImage = "imageAttribution-module--previewImage--sSY+X";
export var attribution = "imageAttribution-module--attribution--PwBve";
export var imageLinkStyle = "imageAttribution-module--imageLinkStyle--e1oBW";
export var imageAttributionContainer = "imageAttribution-module--imageAttributionContainer--4LS8y";